import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CredenciaisAdmin, SessaoAdmin } from '../interfaces/admin';

@Injectable({ providedIn: 'root' })
export class AdminAuthService {
  private accessToken: string | null = null;

  constructor(private readonly http: HttpClient) {}

  login(credenciais: CredenciaisAdmin): Observable<SessaoAdmin> {
    return this.http
      .post<SessaoAdmin>(`${environment.api}/auth/login`, credenciais)
      .pipe(tap((sessao) => (this.accessToken = sessao.accessToken)));
  }

  logout(): void {
    this.accessToken = null;
  }

  isAuthenticated(): boolean {
    return this.accessToken !== null;
  }

  getAccessToken(): string | null {
    return this.accessToken;
  }
}
